/**
 * @desc 查询周计划列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanWeekQueryRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanWeekResponse>>> {
  return defHttp.post({
    url: '/web/plan/week/query',
    data,
  });
}

export function mock(
  data: defs.PlanWeekQueryRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanWeekResponse>>> {
  return defHttp.post({
    url: '/mock/web/plan/week/query',
    data,
  });
}
